import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Music, Loader2 } from "lucide-react";
import { motion } from "framer-motion";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [acceptCgu, setAcceptCgu] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      navigate('/engagement');
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'inscription");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white rounded-3xl shadow-[0_10px_60px_rgba(44,53,49,0.06)] border border-[#EBE7E0] p-8 sm:p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#6B8576] rounded-3xl flex items-center justify-center mx-auto mb-5">
            <Music className="w-7 h-7 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-semibold text-[#2C3531]" style={{ fontFamily: 'Outfit' }}>Créer mon compte</h1>
          <p className="text-[#6A7771] text-sm mt-1.5">Accédez gratuitement à tous les outils</p>
        </div>

        {error && <div className="bg-red-50 text-[#B86666] p-3.5 rounded-2xl text-sm mb-5 border border-red-100" data-testid="register-error">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Prénom</label>
            <input type="text" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required data-testid="register-name" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Email</label>
            <input type="email" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required data-testid="register-email" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Mot de passe</label>
            <input type="password" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required data-testid="register-password" />
          </div>
          <label className="flex items-start gap-2.5 cursor-pointer">
            <input type="checkbox" checked={acceptCgu} onChange={e => setAcceptCgu(e.target.checked)} className="mt-1 w-4 h-4 rounded border-[#EBE7E0] text-[#6B8576] focus:ring-[#6B8576]/20" data-testid="register-cgu-checkbox" />
            <span className="text-xs text-[#6A7771] leading-relaxed">J'accepte les <Link to="/cgu" className="text-[#6B8576] hover:underline" target="_blank">Conditions Générales d'Utilisation</Link> et la <Link to="/confidentialite" className="text-[#6B8576] hover:underline" target="_blank">Politique de confidentialité</Link></span>
          </label>
          <button type="submit" disabled={loading || !acceptCgu} className="w-full py-3 bg-[#6B8576] text-white rounded-full font-medium hover:bg-[#546A5E] transition-all duration-300 disabled:opacity-50 text-sm" data-testid="register-submit">
            {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : "S'inscrire gratuitement"}
          </button>
        </form>
        <p className="text-center text-sm text-[#6A7771] mt-7">Déjà inscrit ? <Link to="/login" className="text-[#6B8576] font-medium hover:underline">Se connecter</Link></p>
      </motion.div>
    </div>
  );
}
